/**
 * Looks for a script tag containing the section data
 * and returns the parsed result
 * @example
 *  <div id="{{ section.id }}" class="shopify-section">
 *      <script id="{{ section.id }}__data">{ "foo": "bar" }</script>
 *  </div>
 *
 * @param {HTMLElement} sectionElement
 */
export function getSectionData(sectionElement) {
  // the section id contains an additional prefix.
  const scriptElementId = stripSectionIdPrefix(sectionElement.id);

  const scriptElement = sectionElement.querySelector(
    "#" + scriptElementId + "__data"
  );

  if (scriptElement instanceof HTMLScriptElement) {
    return JSON.parse(scriptElement.text);
  }
}

/**
 * The section root element id contains an additional prefix,
 * use this function to remove it.
 *  * @example
 *  <div id="{{ section.id }}" class="shopify-section">
 *      <button id="{{ section.id"__button" }}>Click me</button>
 *  </div>
 *
 * @param {string} sectionId
 */
export function stripSectionIdPrefix(sectionId) {
  return sectionId.replace(/^shopify-section-/, "");
}

/** @param {HTMLElement} element */
export function getAnchorElementHref(element) {
  if (element instanceof HTMLAnchorElement) {
    return element.href;
  }
}

/** @param {HTMLElement} element */
export function hideElement(element) {
  element.style.display = "none";
}

/** @param {HTMLElement} element */
export function showElement(element) {
  element.style.display = "block";
}

/**
 *
 * @returns {true | void} true when user prefers reduced motion
 */
export function prefersReducedMotion() {
  // Grab the prefers reduced media query.
  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (!mediaQuery || mediaQuery.matches) {
    return true;
  }
}

/**
 * @returns {number} total height of site header in pixels
 */
export function getHeaderHeight() {
  const announcementBarHeight = document.querySelector("#announcement-bar-container");
  const headerHeight = document.querySelector("header");

  let heightPixels = 0;

  if (headerHeight instanceof HTMLElement) {
    heightPixels += headerHeight.offsetHeight;
  }
  if (announcementBarHeight instanceof HTMLElement) {
    heightPixels += announcementBarHeight.offsetHeight;
  }

  return heightPixels;
}

/**
 * @param {number} price
 * @param {string} [locale]
 * @param {string} [currencyCode]
 */
export function formatPrice(price, locale, currencyCode = "GBP") {
  return price.toLocaleString(locale, {
    style: "currency",
    currency: currencyCode,
  });
}

/**
 * @param {number} key line item key
 * @see https://shopify.dev/api/ajax/reference/cart#update-line-item-quantities
*/
export async function removeCartLineItem(key) {
  const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });
  const data = await response.json();
  return data;
}

/**
 *
 * @returns user cart
 */
export async function getCart() {
  const response = await fetch(window.Shopify.routes.root + "cart.js")
  const data = await response.json();
  return data;
}

export function onDOMReady(callback){
  if (
      document.readyState === "complete" ||
      (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

export function htmlElementExistsVerify(elements) {
  let passed = true;
  const keys = Object.keys(elements);

  keys.filter(function(key) {
    if (!elements[key]) {
      console.warn( `${key} not found`);
      passed = false;
    }
  });
  return passed;
}

export function templateToHtml(template, elSelector) {
    const textFromTemplate = template.childNodes[0].wholeText;
    const parser = new DOMParser();
    const html = parser.parseFromString(textFromTemplate, 'text/html');
    return html.querySelector(elSelector);
}

export async function hasPreorderItems(cart) {
  const preorderItems = cart.items.find(item => {
    if(item.properties && item.properties['_is_preorder']) {
      return !!item.properties['_is_preorder'];
    }
  });
  if(typeof(preorderItems)!== 'undefined'){
    return !!preorderItems.length;
  }  
}

export async function setPreorderOnCartLevel(isPreorder) {
  const preorderValue = isPreorder ? isPreorder : null;

  return await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        _is_preorder: preorderValue
      }
    })
  });
}